import axios from "axios";
import { AddressFormType, AddressType } from "../types";
const USER_API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const BASE_ROUTE = "/api/v1/useraddresses";

class UserAddressService {
  static async getUserAddresses(): Promise<{ data: AddressType[] }> {
    const response = await axios.get(
      `${USER_API_BASE_URL}${BASE_ROUTE}`,
      this.getAuthHeader()
    );
    return response.data;
  }

  static async createUserAddress(data: AddressFormType) {
    return axios.post(
      `${USER_API_BASE_URL}${BASE_ROUTE}`,
      data,
      this.getAuthHeader()
    );
  }

  static async updateUserAddress(
    id: string,
    data: AddressFormType
  ): Promise<AddressType> {
    return axios.put(
      `${USER_API_BASE_URL}${BASE_ROUTE}/${id}`,
      data,
      this.getAuthHeader()
    );
  }

  static async deleteUserAddress(id: string) {
    return axios.delete(
      `${USER_API_BASE_URL}${BASE_ROUTE}/${id}`,
      this.getAuthHeader()
    );
  }

  static getAuthHeader() {
    return {
      headers: {},
      withCredentials: true,
    };
  }
}

export default UserAddressService;
